import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    captionClassName,
    SubheaderClassName,
    magazineTileClassName,
    imageClassName,
    boxClassName,
} from '@archipro-design/aria';

import type { MagazineTileVariables } from './MagazineCard';

export const Card: StyleRule<{ tileVars: MagazineTileVariables }> = ({
    tileVars,
}) => ({
    gridGap: pxToRem(17),
    gridTemplateRows: `${tileVars.rootHeight} 1fr`,

    [`& .${magazineTileClassName}`]: {
        maxWidth: '100%',
    },
});

export const TileContainer: StyleRule = ({ theme }) => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    [theme.screen.clamped]: {
        [`& .${magazineTileClassName}`]: {
            width: '100%',
            [`& > .${boxClassName}`]: {
                width: '100%',
            },
        },
    },
});

export const TileLegacyThumbnail: StyleRule = ({ theme }) => ({
    [theme.screen.clamped]: {
        [`& .${imageClassName}`]: {
            width: '100%',
        },
    },
});

export const CardContent: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18]),
    gap: pxToRem(4),

    [`& .${captionClassName}`]: {
        lineHeight: 1.25,
    },

    [theme.screen.laptop]: {
        padding: 0,
        [`& .${captionClassName}`]: {
            lineHeight: 1.3,
        },
    },
});

export const Subtitle: StyleRule = ({ theme }) => ({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',

    [`&.${SubheaderClassName}`]: {
        marginBottom: pxToRem(6),
        minHeight: pxToRem(36),

        [theme.screen.laptop]: {
            marginBottom: pxToRem(32),
            minHeight: pxToRem(72),
        },
    },
});

export const Title: StyleRule = ({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-end',

    [`&.${SubheaderClassName}`]: {
        marginBottom: pxToRem(8),

        [theme.screen.laptop]: {
            height: pxToRem(96),
            marginBottom: pxToRem(16),
        },
    },
});
